<template>
  <div class="index_warp">
   
    <div style="display:flex;">
      <div class="left">
      
    <div class="top" v-show="userInfo.is_brand == 1">
      
      <div class="top_block"
           @click="toPage('/teacherPaper')"
           >

        <div class="images">
          <img src="@/static/center/teacher.png"
               alt="">
        </div>
        <div class="text">
          教师试卷
        </div>

      </div>
         <div class="top_block"
           @click="toPage('/new')"
           >

        <div class="images">
          <img src="@/static/数据中心.png"
               alt="">
        </div>
        <div class="text">
          数据中心
        </div>

      </div>
     
      
      
      

      <div class="top_block"
           @click="toPage('/mytestpaper')"
           >

        <div class="images">
          <img src="@/static/index/paper.png"
               alt="">
        </div>
        <div class="text">
        我的试卷
        </div>

      </div>

      
    </div>
   
  </div>
   
  </div>
  
   
  </div>
</template>

<script setup>
import { SearchOutlined } from '@ant-design/icons-vue'
import { reactive, ref, toRef, toRefs } from '@vue/reactivity'
import { backgColorProperty } from './property.js'
import { onMounted, onUnmounted } from '@vue/runtime-core'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { getHomeKnowledge, getHomeWeak } from '@/api/knowledge.js'
import { getTopic } from '@/api/topic.js'
import Card from './components/card.vue'
import CardWeak from './components/cardWeak.vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { getTestModeSubject } from "@/api/subject.js"
import { messageStatus } from '@/api/home.js'
import { getLearnProcess } from '@/api/learnProcess.js'
import { backgoundColor } from './background.js'
import { getOnlineAnswer } from '@/api/post.js'
 import emitter from '@/utils/eventBus';

const router = useRouter()
let list = ref([])
let keywords = ref('')
let weakLlist = ref([])
let totalScore = ref(0)
let dayiList = ref([])
let autoModalFlag = ref(false)
let backgColor = backgColorProperty
let timeInterValId = ref(0)
let userInfo = reactive({})
let store = useStore()
const edu_grade_id = ref(null)
let bgColors = backgoundColor
let discuss = ref(1)

let unreadMsgCount = ref(0)
const timer = ref(null)
let progressList = ref([])

const searchTopic = async () => {
  if (!keywords.value) {
    return message.warn('请输入题目ID')
  }
  const { data } = await getTopic({
    question_id: keywords.value
  })
  if (data.list.length) {
    router.push('/showTopic?topicId=' + keywords.value)
  }
}


onMounted(() => {
  edu_grade_id.value = JSON.parse(window.localStorage.getItem('userInfo')).edu_grade_id
  getTestSubject()
  getKnowledge()
  getProgress()
  getWeakness()
  getUserInfo()
  getDayi()
  discuss.value = JSON.parse(window.localStorage.getItem('userInfo')).discuss

  totalScore.value = JSON.parse(window.localStorage.getItem('totalScore'));
  // this.$EventBus.on('totalScoreEdit', data => {
  //   totalScore.value = data
  // })
   let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    if (userInfo.user_type_id == 101 && !userInfo.vip_end_time) {
      autoModalFlag.value = true
    }
  if (totalScore.value > 0) {
    window.localStorage.setItem('score_dialog', false)
  }
  store.commit('CLEAR_ROUTE_CACHE')

  getMsgUnread()
  reqMsgLoop()
     let subjectList = JSON.parse(window.localStorage.getItem('subjectListData'))
const hasChinese = subjectList.some(item => item.subject_id == 1);
const hasEnglish = subjectList.some(item => item.subject_id == 3);
 
if (subjectList.length == 1 && (hasChinese || hasEnglish) || 
    (subjectList.length == 2 && hasChinese && hasEnglish)) {
      
  isShow.value = false;
}else{
   
  isShow.value = true;
}
})

onBeforeRouteLeave((to, from, next) => {
  let includeRouteNames = ['/mytestpaper', '/testpaper/template', '/dayi/info']
  if (includeRouteNames.includes(to.name)) {
    store.commit('SET_ROUTE_LIST', to.name)
  }
  next()
})

onUnmounted(() => {
  window.clearTimeout(timer.value)

})
const toConsultation = () => {
  router.push('/consultation')
}
 
const getDayi = async () => {
  const { data } = await getLearnProcess()
  dayiList.value = data.list
}
const toPredict = () => {
  router.push('/predict')
}
const getProgress = async () => {
  const { data } = await getHomeWeak() 
  progressList.value = data.list

}
 
const toGoal = () => {
  router.push('/userInfo/goal')
}
// 获取用户信息
const getUserInfo = () => {
  let cacheUserInfo = JSON.parse(window.localStorage.getItem('userInfo'))
  for (const key in cacheUserInfo) {
    userInfo[key] = cacheUserInfo[key]
  }
}

let showTemplateTest = ref(false)
let showTop = ref(false) //等确定是否显示模板组卷再显示其它组卷模块
let isShow = ref(null)
// 获取备考科目
const getTestSubject = async () => {
  try { 
    let { data } = await getTestModeSubject({has_district:1})
    console.log('data', data)
    if (data && data.list && data.list.length > 0) {
      showTemplateTest.value = true
    } else {
      showTemplateTest.value = false
    }
    showTop.value = true
  } catch {
    showTop.value = true
  }

}

// 跳转页面
const toPage = (str) => {
 
  if(str== "/new"){
  
   emitter.emit('newExport', true)
   
  }else{
      router.push(str)
  }
     

}
const getKnowledge = async () => {
  const { data } = await getHomeKnowledge()
  list.value = data.list
}

const getWeakness = async () => {
  const { data } = await getOnlineAnswer()
  weakLlist.value = data.list
}
//点击帖子条目跳转
const todayiInfo = (item) => {
  let form = {
    status: status.value
  }
  if (status.value == 2) {
    form.discuss_id = item.discuss_parent_id
  } else {
    form.discuss_id = item.discuss_id
  }
  router.push('/dayi/info?form=' + JSON.stringify(form))
}
const toInfo = (item) => {
  let form = {
    knowledge_id: item.knowledge_id,
    subject_id: item.subject_id
  }
  window.sessionStorage.removeItem('images')
  window.sessionStorage.removeItem('paper')
  window.sessionStorage.removeItem('testpaperCardIndex')
  // router.push('/testpaper/paperinfo?isKnowledge=1&form=' + JSON.stringify(form))
  router.push('/doPaper?isKnowledge=1&form=' + JSON.stringify(form))

}

const toWeakInfo = (item) => {
  let form = {
    knowledge_id: item.knowledge_id,
    subject_id: item.subject_id
  }
  window.sessionStorage.removeItem('images')
  window.sessionStorage.removeItem('paper')
  window.sessionStorage.removeItem('testpaperCardIndex')
  router.push('/doPaper?isKnowledgeWeak=1&form=' + JSON.stringify(form))

}
const doPaper = (item) => {
  window.localStorage.removeItem('testpaperCardIndex')
  window.localStorage.removeItem('paper')
  window.localStorage.removeItem('images')
  router.push('/doPaper?user_paper_id=' + item.user_paper_id)
}

const getMsgUnread = async () => {
  try {
    var res = await messageStatus({ platform: 1, client: 1, uid: userInfo.user_id })
  } catch (error) {
    console.log(error)
    window.clearTimeout(timer)
  }

  unreadMsgCount.value = res.data.unread
}

const reqMsgLoop = () => {
  timer.value = window.setTimeout(async () => {
    getMsgUnread()
    reqMsgLoop()
  }, 5000)
}

const toMsg = async () => {
  router.push('/message')
}

</script>

<style lang="scss" scoped>
.index_warp {
 .autoModal { 
    position: fixed;
    left: 197;
    top: 0;
    width: 90%;
    height: 100%;
    z-index: 9999;
    opacity: 1.5;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    .btntext {
      position: fixed;
      left: 800rem;
      top: 700rem;
      .text {
        color: var(--light-333333, #333);
        text-align: center;

        font-size: 24rem;
        font-style: normal;
        font-weight: 600;
        line-height: 36rem; /* 150% */
      }
    }
    .openButton {
      ::v-deep .ant-btn {
        display: flex;
        width: 360rem;
        height: 64rem;
        justify-content: center;
        align-items: center;
        gap: 10rem;
        flex-shrink: 0;
        border-radius: 8rem;
        background: linear-gradient(100deg, #fdecc9 0%, #e9c383 100%);
        box-shadow: 0rem 8rem 16rem 0rem rgba(0, 0, 0, 0.1);
      }
    }
  }
  // margin: 0 auto;
  margin-top: 4vh;
  // margin-left: 90rem;
  margin-left: 4.76vw;

  .mode {
    margin-bottom: 7rem;
    font-size: 22rem;
    font-weight: 800;
    color: #ffffff;
    text-indent: 5rem;
  }
  .progress {
  
      width: 1000rem;
      height: 328rem;
    
      background: rgba(1, 61, 253, 0.6);
      border-radius: 50rem;
      overflow: hidden;
      .more {
        padding: 2rem 40rem;
        font-size: 28rem;
        background: rgba(0, 0, 0, 0.1);
        font-weight: 400;
        color: #ddd;
        border-radius: 35rem;
        cursor: pointer;
      }
      .title {
        font-size: 28rem;
        font-weight: 600;
        color: #ffffff;
        margin-top: 20rem;
        margin: 20rem 32rem 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .papers {
        &::-webkit-scrollbar-thumb {
          background-color: #ffffff52;
        }
       
        display: flex;
        margin:20rem 0rem 20rem 32rem;
        overflow-x: scroll;
        gap:24rem;
        .noData{
           display:flex;
  justify-content: center;
  margin-top: 40rem;
  color: var(--dark-60-ffffff, rgba(255, 255, 255, 0.60));
 
font-size: 20rem;
font-style: normal;
font-weight: 400;
height: 140rem;
line-height: 30rem; /* 150% */
margin-left: 348rem;
        }
        .paperItem{
          display: flex;
width: 224rem;
height: 198rem;
min-width: 224rem;
padding: var(--Spacing-S, 8rem);
// flex-direction: column;
align-items: flex-start;
border-radius: 48rem;
background: #B29BFA;
        .paper {
         display: flex;
padding: var(--Spacing-L, 24rem);
flex-direction: column;
align-items: flex-start;
gap: 10rem;
flex: 1 0 0;
align-self: stretch;
border-radius: 40rem;
background: #FFF;
box-shadow: 0rem 2rem 8rem 0rem #622FD7;

          .tag {
           overflow: hidden;
color: var(--light-333333, #333);
text-align: center;
text-overflow: ellipsis;
display: flex;
height: 72rem;
justify-content: center;
align-items: center;
align-self: stretch;
font-size: 20rem;
font-style: normal;
font-weight: 600;
line-height: 30rem; /* 150% */
          }
          .score{
            display: flex;
flex-direction: column;
align-items: flex-start;
gap: var(--Spacing-XS, 4rem);
align-self: stretch;
font-size:16rem
 

          }
          .content {
            margin-top: 70rem;
            height: 60rem;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            font-size: 24rem;
            line-height: 33rem;
            font-weight: bold;
            padding: 0 10rem;
          }
          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 22rem;
            font-weight: bold;
            color: #000000;
            background-color: #ffffff;
            margin: 0 auto;
            width: 130rem;
            height: 44rem;
            border-radius: 40rem;
            margin-top: 9rem;
            cursor: pointer;
          }
          .time {
            font-size: 20rem;
            font-weight: 500;
            color: #0d2878;
            text-align: center;
            margin-top: 10rem;
          }
        }
      }}
    }
    .right {
    width: 480rem;
    height: 496rem;
    box-shadow: 0rem 0rem 0rem 0rem rgba(229, 229, 229, 1);
    background: #fefdf9;
    border-radius: 60rem;
    border: 20rem solid #fac376;
    margin-left: 40rem;
    overflow: hidden;
    margin-top: 20rem;
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        margin-top: 24rem;
        &:nth-child(1) {
          text-indent: 34rem;
          font-size: 24rem;
          font-weight: 600;
          color: #1A1A1A;
        }
        &:nth-child(2) {
          color: #999;
          font-weight: 400;
          font-size: 24rem;
          margin-right: 24rem;
          cursor: pointer;
        }
      }
    }
    .content_wrap {
      .text{
            display: flex;
    justify-content: center;
    margin-top: 39%;
  
    color: var(--light-cccccc, #CCC);

 
font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 30px; /* 150% */
      }
      overflow-y: scroll;
      height: 695rem;
      /* 滚动条上的滚动滑块. */
      &::-webkit-scrollbar-thumb {
        background-color: #d4af49da;
      }
      /*  滚动条轨道. */
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6rem rgba(196, 129, 4, 0.5);
        box-shadow: inset 0 0 6rem rgba(196, 129, 4, 0.5);
      }
    }
    .item {
      position: relative;
      width: 380rem;
      height: 190rem;
      border-radius: 10rem;
      box-shadow: 0rem 0rem 4rem -1rem rgba(177, 177, 177, 0.5);
      background: #ffe9e0;
      margin: 0 auto;
      margin-top: 20rem;
      margin-bottom: 30rem;
      overflow: hidden;
      .topic_name {
        margin: 15rem 20rem 8rem;
        font-weight: bold;
        font-size: 24rem;
        color: #b76c3c;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .content {
        padding: 0 20rem;
        font-weight: 500;
        color: #666666;
        font-size: 20rem;
        line-height: 28rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .btn {
        position: absolute;
        bottom: 16rem;
        right: 20rem;
        // background: #ff664e;
        border-radius: var(--Radius-MAX, 100rem);
        border: 1rem solid #FF664E;
        font-size: 16rem;
        font-weight: 400;
        color: #FF664E;
        padding: 7rem 21rem;
        margin-top: 16rem;
        cursor: pointer;
      }
    }
  }
  .left{
    margin-top:20rem;
  }
  .topList{
    display: flex;
    gap:16rem;
    .topCard{
      display: flex;
justify-content: center;
align-items: center;
gap: var(--Spacing-S, 8rem);
flex: 1 0 0;
width:238rem;
height:88rem;
align-self: stretch;
border-radius: var(--Radius-L, 28rem);
background: linear-gradient(100deg, #088BFF 0%, #63EFFF 100%);
box-shadow: 4rem 4rem 4rem 0rem rgba(255, 255, 255, 0.60) inset, 0rem 2rem 10rem 0rem rgba(3, 48, 143, 0.60);
span{
  color: var(--light-333333, #333);
 
font-size: 20rem;
font-style: normal;
font-weight: 600;
line-height: 30rem; /* 150% */
}
    }
  }
  .top {
    display: flex;
    padding: var(--Spacing-L, 24rem);
    align-items: flex-start;
    align-content: flex-start;
    align-self: stretch;
    flex-wrap: wrap;
    width:1000rem;
    height:368rem;
    margin-top: 40rem;
    border-radius: 48rem;
    background: linear-gradient(130deg, #b6cdf6 0%, #fff 79.81%);
    box-shadow: 2rem 2rem 6rem 0rem rgba(255, 255, 255, 0.6) inset,
      0rem 2rem 10rem 0rem rgba(3, 48, 143, 0.6);
    .top_block {
      display: flex;
width: 238rem;
height: 160rem;
flex-direction: column;
justify-content: center;
align-items: center;
gap: var(--Spacing-XS, 4rem);

      .white_wrap {
        width: 302rem;
        width: calc(100% - 16rem);
        height: 352rem;
        margin: 8rem;
        padding: 32rem;
        background: #ffffff;
        box-shadow: 0rem 2rem 6rem 0rem #be771f;
        border-radius: 24rem;
      }
      .text {
        font-size: 24rem;
        // font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 36rem;
        // margin-bottom: 16rem;
      }
      .content {
        font-size: 20rem;
        font-weight: 400;
        line-height: 30rem;
        color: #666666;
        span {
          display: block;
          margin-bottom: 4rem;
        }
      }
      .images {
      
        img {
          width: 80rem;
          height: 80rem;
          // position: absolute;
        }
      }
    }
  }
}
.top_input {
  margin-top: 20rem;
  width: 91%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  :deep .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused {
    box-shadow: 0 0 0;
  }
  .goal_text {
    color: var(--light-333333, var(--neutral-color-333333, #fff));
    font-size: 24rem;
    font-style: normal;
    font-weight: 700;
    line-height: 32rem; /* 131.25% */
  }
  .btn_goal {
    display: flex;
    padding: var(--spacer-8_xs, 8rem) var(--spacer-24_m, 24rem);
    align-items: center;
    gap: var(--spacer-8_xs, 8rem);
    border-radius: 100rem;
    border: 1rem solid #f37f21;
    background: #f37f21;
    .text {
      overflow: hidden;
      color: var(--light-ffffff, #fff);
      text-overflow: ellipsis;
      font-size: 20rem;
      font-style: normal;
      font-weight: 600;
      line-height: 30rem; /* 150% */
    }
  }
  .ant-input-affix-wrapper {
    width: 320rem;
    height: 48rem;
    padding: 0rem;
    box-shadow: 0;
    // border-radius: 30rem;
    padding-right: 12rem;
    background: transparent;
    border: 0;
    border-bottom: 1rem solid rgba(255, 255, 255, 0.38);
    font-weight: 400;

    :deep .ant-input-suffix {
      color: #fff;
      padding: 0 0rem;
      img {
        width: 32rem;
        height: 32rem;
        cursor: pointer;
      }
    }
    :deep .ant-input {
      font-size: 24rem;
      line-height: 36rem;
      font-weight: 400;
      padding: 0;
      color: rgba(255, 255, 255, 0.38);
      &::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.38);
        font-weight: 400;
      }
      &::-moz-placeholder {
        color: rgba(255, 255, 255, 0.38);
        font-weight: 400;
      }
    }
  }
  .ant-input-affix-wrapper-focused {
    // background-color: rgb(250, 250, 250, 1);
    box-shadow: 0 0 0;
    :deep .ant-input-suffix {
      // color: #336;
    }
    :deep .ant-input {
      // color: #336;
      color: #fff;
      &::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.38);
      }
      &::-moz-placeholder {
        color: rgba(255, 255, 255, 0.38);
      }
    }
  }

  :deep .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 0;
  }
  :deep .ant-input {
    background-color: transparent;
    padding-left: 12rem;
    &::-webkit-input-placeholder {
      color: #eeeeff;
    }
    &::-moz-placeholder {
      color: #eeeeff;
    }
  }
}

.msg-count {
  display: flex;
  padding: 4rem 12rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
  border-radius: 16rem;
  // border: 1rem solid #fff;
  background: var(--Error-color_06, #f44336);
  color: #fff;
  font-size: 16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 24rem;
  position: relative;
  top: -12rem;
  left: -12rem;
}
</style>